import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress noisy "ResizeObserver loop completed with undelivered notifications"
// errors emitted by radix-ui Select/Dialog inside React dev overlay. Harmless.
const RESIZE_OBSERVER_ERR_RE = /ResizeObserver loop/;
window.addEventListener("error", (e) => {
  if (e?.message && RESIZE_OBSERVER_ERR_RE.test(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});
window.addEventListener("unhandledrejection", (e) => {
  if (e?.reason?.message && RESIZE_OBSERVER_ERR_RE.test(e.reason.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
